module.exports = __webpack_public_path__ + "static/scope-c27a53b979ba2fa1975ade656a8f5392.png";